import Core from '../../../../Core/Core';
import { IconTextButton } from '../../../Shared/Buttons/IconTextButton';
import { ButtonColors } from '../../../Shared/Buttons/NineSliceButton';

export class ShareButton extends IconTextButton {
    constructor(width: number, height: number) {
        super({
            width,
            height,
            btnText: Core.local.getText('Share'),
            color: ButtonColors.BLUE,
            fontSize: 65,
            outline: 0x2653a9,
            iconId: 'commonui/button-icon-camera',
        });
    }
}
